import React from 'react'
import Achievement from './Achievement'

const Achievements = ({ achievements }) => {
  return (
    <div className="flex flex-col">
      <span className="text-gray-500 font-bold">Realizări</span>
      <hr className="w-[60%] bg-over-ternary-background mt-1" />
      <div className="mt-1 flex-col flex  sm:flex-row gap-3 text-over-primary-background">
        {achievements?.length > 0 ? (
          achievements?.map(achievement => (
            <Achievement
              key={`achievement-${achievement?.id}`}
              title={achievement?.name}
              icon={achievement?.icon}
            />
          ))
        ) : (
          <span className="text-over-primary-backround font-semibold text-sm">
            Nu există realizări
          </span>
        )}
      </div>
    </div>
  )
}

export default Achievements
